import { BuyersCompaniesAndUsersDataModel } from 'models/seller/customers/BuyersCompaniesAndUsersModel';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Trash } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

type PropTypes = {
  company: BuyersCompaniesAndUsersDataModel;
  handleDelete: (id: number) => Promise<void>;
};

export const CustomerDeleteButton = ({ company, handleDelete }: PropTypes) => {
  const { t } = useTranslation('components');
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleDeleteConfirmation = async () => {
    handleDelete(company.id);
    handleClose();
  };

  return (
    <>
      <Button variant='btn btn-eleczap-noBorder' onClick={handleShow}>
        <Trash className='status-icon-danger' size={20}></Trash>
      </Button>
      <Modal size='sm' show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('customers.hd_CancelInvitation')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t('customers.inf_CancelInvitationDescription', {
            companyName: company.name,
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            {t('common.btn_Close')}
          </Button>
          <Button variant='danger' onClick={handleDeleteConfirmation}>
            {t('common.btn_Ok')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
